module.exports = __webpack_public_path__ + "static/media/logo-biro.f36dcbbb.png";